import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import AuctionBase from "../AuctionBase";
import React from "react";

import { getProto } from "../../../utils/proto/index";

export const SealedAuctionFloor = ({
  auction,
  shopId,
  productId,
  now,
  endEpoch,
  onPlaceBid,
  customerId,
  shopLoginUrl,
  statefulPurchaseQuantity,
  setStatefulPurchaseQuantity,
  setVariant,
}) => {
  const [statefulBids, setStatefulBids] = useState([]);

  useEffect(() => {
    if (getProto(window.location.search)) {
      setStatefulBids([
        {
          price: 10,
        },
        {
          price: 20,
        },
        {
          price: 50,
        },
      ]);
    }
  }, []);

  return (
    <AuctionBase
      auction={auction}
      currentPrice={
        statefulBids.length > 0
          ? statefulBids.reduce(function (prev, current) {
              return prev.price > current.price ? prev : current;
            }).price
          : 0
      }
      targetDate={endEpoch}
      statefulPurchaseQuantity={statefulPurchaseQuantity}
      setStatefulPurchaseQuantity={setStatefulPurchaseQuantity}
      onBidClick={onPlaceBid}
      setVariant={setVariant}
    />
  );
};
